var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "DatePickerView u-InputMarginView",
      class: [
        _vm.modes.map((m) => `DatePickerView--${m}`),
        { "DatePickerView--error": _vm.isError && _vm.required },
      ],
      style: {
        maxWidth: _vm.maxWidth,
        minWidth: _vm.minWidth,
        margin: _vm.margin,
      },
    },
    [
      _vm.title
        ? _c(
            "label",
            {
              staticClass: "DatePickerViewLabel",
              attrs: { for: `DatePickerView-input-${_vm._uid}` },
            },
            [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("date-picker", {
        staticClass: "DatePickerViewInput",
        class: { mixed: _vm.isMixed && !_vm.isReplaceValue },
        attrs: {
          lang: "en",
          "value-type": "YYYY.MM.DD",
          type: _vm.type,
          format: _vm.format,
          "time-picker-options": _vm.timePickerOptions,
          placeholder: _vm.placeholder,
          clearable: _vm.clearable,
        },
        model: {
          value: _vm.innerValue,
          callback: function ($$v) {
            _vm.innerValue = $$v
          },
          expression: "innerValue",
        },
      }),
      _vm._v(" "),
      _c("svg-view", { attrs: { name: "calendar" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }